module.exports = __webpack_public_path__ + "img/ped-logo-new.087dbeff.png";